module.exports = __webpack_public_path__ + "static/media/vic26.efda2f8e.JPG";